import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { LocalStoreManager, LookupService, ShowToastrService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { take, takeUntil } from "rxjs/operators";
import { ReceiptPaymentModel, ReceiptPaymentTypeEnum } from "src/app/frontoffice/order/model/receiptpayment.model";
import { Invoice } from "../../../order/model/invoice.model";
import { DriverLookup, DriverSettlementModel, SettlementDateViewModel } from "../../model/usersettlement.model";
import { SettlementInvoiceModel } from "../../model/settlementinvoice.model";
import { InvoicesModalComponent } from "../invoicesmodal/invoicesmodal.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SettlementReadInvoiceEnum, SettlementReadInvoiceModel } from "../../model/settlementreadinvoice.model";
import { SplashFormService } from "../../../../../../projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { SimpleMenuComponent } from "../cashiersettlement-form/settlementsettingmenu";
import { SettlementFormSettingModel } from "../cashiersettlement-form/settlementformsetting/settlementformsetting.model";
import { ShippingCostReducedKind } from "src/app/gnr/branch/branch.enum";
import { CostSpentFormSettingModel } from "src/app/frontoffice/cost/spentcost/costspentformsetting.model";
import { DriverSettlementFormSettingModel } from "../driversettlementformsetting.model";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { DriversettlementsettingFormComponent } from "../driversettlementsetting-form/driversettlementsetting-form.component";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { PaymentMethodType } from "../../model/payment-method.enum";

@Component({
  selector: "driversettlement-form.component",
  templateUrl: "./driversettlement-form.component.html",
  styleUrls: ["./driversettlement-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverSettlementFormComponent extends BaseFormComponent<DriverSettlementModel> {
  userLookup: Lookup[];
  PaymentMethod: Lookup[];
  deactivateSave: boolean;
  menu = SimpleMenuComponent;
  formsetting: SettlementFormSettingModel;
  RowState: typeof RowState = RowState;
  invoice: Invoice[];
  showDetail: boolean;
  costSpentFormSettingModel: CostSpentFormSettingModel = new CostSpentFormSettingModel();
  SettlementEnum: typeof SettlementReadInvoiceEnum = SettlementReadInvoiceEnum;
  PaymentMethodType: typeof PaymentMethodType = PaymentMethodType;
  receiptPaymentType: Lookup[];
  hasAccountingModule: boolean;
  ShippingCostReducedKindCode: number;
  hasDetailLedger: boolean;
  confirmDialog: boolean = false;
  receiveId: number;
  constructor(
    sts: ShowToastrService,
    private lookupService: LookupService,
    private storage: LocalStoreManager,
    private datatransfer: Datatransfer,
    __id: FormContainerModel,
    private _tabsservice: TabularService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    public splashFormService: SplashFormService,
    private lookupservice: LookupService
  ) {
    super(selectorService, cd);
    this.currentrow = this.datatransfer?.currentrow;
    this.apiName = "DriverSettlement";
    this.label = this.datatransfer?.label;
    this.areaName = this.datatransfer?.areaName;
    this._id = __id;
    this.tabsservice = _tabsservice;
    this.hasAccountingModule =
      this.accountService.authService.currentInformation().AccountingKind === SoftWareLicenseKind.AccountingAdvancedWeb ||
      this.accountService.authService.currentInformation().AccountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb ||
      this.accountService.authService.currentInformation().AccountingKind === SoftWareLicenseKind.AccountingWeb;
  }
  async ngOnInit() {
    super.ngOnInit();
    this.FillData();
  }
  addControl() {
    this.setValue("UntilDate", this.model.UntilDate);
    this.setValue("UntilTime", this.model.UntilTime);
    this.setValue("SettledPersonnelId", this.model.SettledPersonnelId);
    this.setValue("PayableTotal", this.model.PayableTotal);
    this.setValue("CourierShippingCost", this.model.CourierShippingCost);
    this.setValue("ShippingCost", this.model.ShippingCost);
    this.setValue("PayableWithCourierShippingCost", this.model.PayableWithCourierShippingCost);
    this.setValue("PayableWithShippingCost", this.model.PayableWithShippingCost);
    this.setValue("TerminalNumber", this.model.TerminalNumber);
    this.setValue("OnlinePayment", this.model.OnlinePayment);
    this.setValue("PaymentLink", this.model.PaymentLink);
    this.setValue("Credit", this.model.InvoiceCredit);
    this.setValue("Description", this.model.Description, false);
    this.setValue("Debit", this.model.InvoiceDebit);
    this.setValue("Remain", this.model.Remain);
    this.setValue("NewRemainValue", this.model.NewRemainValue);
    this.setValue("PaymentMethodTitle", this.model.PaymentMethodTitle);
    this.setValue("ReceiptPaymentTypeTitle", this.model.ReceiptPaymentTypeTitle);
    this.setValue("Amount", this.model.Amount);
    this.setValue("OldRemain", this.model.OldRemain);
    this.setValue("TotalPayment", this.model.TotalPayment);
    this.setValue("TotalDeposit", this.model.TotalDeposit);
    this.setValue("AllowedDeficit", this.model.AllowedDeficit);
    this.setValue("ShippingCostReducePrice", this.model.ShippingCostReducePrice);

    if (this.model.ReceiptPayments && this.model.ReceiptPayments.length > 0) {
      this.model.ReceiptPayments.forEach((receipt, i) => {
        if (receipt.ReceiptPaymentTypeTitle) {
          this.setValue("ReceiptPaymentTypeTitle" + i, receipt.ReceiptPaymentTypeTitle);
        }
        if (receipt.PaymentMethodTitle) {
          this.setValue("PaymentMethodTitle" + i, receipt.PaymentMethodTitle);
        }
        if (receipt.Amount) {
          this.setValue("Amount" + i, receipt.Amount);
        }

        this.cd.markForCheck();
      });
    }

    this.FillFormSetting();
    this.cd.markForCheck();
  }
  async FillFormSetting() {
    const ShippingCostReducedKindId = this.accountService.authService.currentBranch.ShippingCostReducedKindId;
    if (ShippingCostReducedKindId) this.ShippingCostReducedKindCode = this.lookupservice.getLookupbyId(ShippingCostReducedKindId).Code;
    if (
      this.ShippingCostReducedKindCode &&
      (this.ShippingCostReducedKindCode == ShippingCostReducedKind.CourierShippingCost ||
        this.ShippingCostReducedKindCode == ShippingCostReducedKind.ShippingCost)
    ) {
      let driverSettlementFormSettingModel = new DriverSettlementFormSettingModel();
      let result = await this.httpCommonService.getList("DriverSettlementFormSetting").pipe(take(1)).toPromise();
      if (result && this.model) {
        this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
        driverSettlementFormSettingModel = <DriverSettlementFormSettingModel>this.storage.getData(ClearableCache.FormSetting);
        this.model.DriverSettlementFormSettingModel = driverSettlementFormSettingModel;
      }
    }
    if (this.hasAccountingModule) {
      this.costSpentFormSettingModel = <CostSpentFormSettingModel>this.storage.getData(ClearableCache.FormSetting);
      if (!this.costSpentFormSettingModel) {
        let result = await this.httpCommonService.getList("CostSpentFormSetting").pipe(takeUntil(this.ngUnsubscribe)).toPromise();
        if (result) {
          this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
          this.costSpentFormSettingModel = <CostSpentFormSettingModel>this.storage.getData(ClearableCache.FormSetting);
        }
      }
      this.model.CostSpentFormSettingViewModel = this.costSpentFormSettingModel;
      if (this.model.CostSpentFormSettingViewModel?.Subledger) {
        this.httpCommonService
          .getItem("SubLedger/HasDetailLedger", this.model.CostSpentFormSettingViewModel.Subledger)
          .pipe(take(1))
          .subscribe((x: boolean) => {
            this.hasDetailLedger = x;
          });
      }
    }
  }
  FillData() {
    this.httpCommonService
      .getList("SettlementFormSetting")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: any[]) => {
        if (result?.length > 0) {
          this.formsetting = result[0];
          this.storage.savePermanentData(result[0], "SettlementFormSetting");
        }
      });
    this.deactivateSave = true;
    if (!this.currentrow)
      this.httpCommonService
        .get("Invoice/HasUnAssignmentInvoice")
        .pipe(take(1))
        .subscribe((data: boolean) => {
          if (data) {
            if (!this.confirmDialog) {
              this.sts.showDialog(this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.HaveUnassignedInvoice"), "");
              this.confirmDialog = true;
            }
          }
          this.getCurrentDate();
          this.getUserLookup();
          // گرفتن نوع پرداخت
          this.getPaymentMethod();
          this.getReceiptPaymentType();
        });
    else {
      this.getUserLookup();
    }
  }

  getReceiptPaymentType() {
    this.lookupService
      .getLookupbyCategory("SALE", "ReceiptPaymentType")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Lookup[]) => {
        this.receiptPaymentType = data.sort((a, b) => a.Code - b.Code);
        this.receiveId = data.find((x) => x.Code == ReceiptPaymentTypeEnum.Receipt).Id;
      });
  }

  checkIsPosPayment(model: any, index: number) {
    this.cd.markForCheck();
    this.checkValidation();
  }

  getCurrentDate() {
    this.httpCommonService
      .getList("DriverSettlement/GetCurrentDate")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: SettlementDateViewModel) => {
        this.setValue("UntilDate", data.UntilDate);
        this.setValue("UntilTime", data.UntilTime);
        this.cd.markForCheck();
      });
  }
  setdefault() {}
  getUserLookup() {
    this.httpCommonService
      .getList("Personnel/ReadUserLookupItems/true")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any[]) => {
        this.userLookup = data.map((item) => ({
          Id: item.Id,
          Title: item.Title,
          PersonnelId: item.PersonnelId,
          TerminalNumber: item.TerminalNumber,
        })) as DriverLookup[];

        this.setValue("SettledPersonnelId", this.model.SettledPersonnelId);

        if (this.userLookup && this.userLookup.length === 1) {
          this.setValue("SettledPersonnelId", this.userLookup[0].Id);
        }
      });
  }
  getPaymentMethod() {
    this.httpCommonService
      .getList("PaymentMethod/PaymentMethodLookUp" + "/" + this.accountService.authService.currentBranchId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Lookup[]) => {
        if (data) {
          this.PaymentMethod = data;
        }
      });
  }
  // برای بایند کردن نام در سند html
  controlName(name: string, index: number): string {
    return name + index;
  }
  changeUser() {}
  receiveInformation() {
    this.showDetail = false;
    this.deactivateSave = true;
    this.setdefault();
    if (!this.formGroup.controls["SettledPersonnelId"].value) {
      this.sts.showToast("danger", "", `${this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.CourierNotArrived")}`);
      return;
    }
    this.splashFormService.openDialog();
    this.model.SettledPersonnelId = this.formGroup.value.SettledPersonnelId;
    this.model.UntilDate = this.formGroup.value.UntilDate;
    this.model.UntilTime = this.formGroup.value.UntilTime;
    this.model.BranchId = this.accountService.authService.currentBranchId;

    this.httpCommonService
      .create("DriverSettlement/DriverSettlement", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: DriverSettlementModel) => {
          this.model = data;
          this.showDetail = true;
          this.deactivateSave = false;
          this.addControl();
          this.addGroup();
          this.splashFormService.closeLoading();
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(
            `${Utilities.getHttpResponseMessage(error)}`,
            this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.Attention")
          );
        }
      );
  }
  openInvoicesModal(invoicekind?: number) {
    let ReadInvoiceModel = new SettlementReadInvoiceModel();
    ReadInvoiceModel.UntilDate = this.formGroup.value.UntilDate;
    ReadInvoiceModel.Status = SettlementReadInvoiceEnum.Delivery;
    ReadInvoiceModel.SettledUserlId = this.formGroup.value.SettledPersonnelId.Id;
    ReadInvoiceModel.UntilTime = this.formGroup.value.UntilTime;
    ReadInvoiceModel.InvoiceIds = this.model.InvoiceIds;
    if (invoicekind === SettlementReadInvoiceEnum.Debit) {
      ReadInvoiceModel.InvoiceIds = this.model.DebitInvoiceIds;
    }
    if (invoicekind === SettlementReadInvoiceEnum.Credit) {
      ReadInvoiceModel.InvoiceIds = this.model.CreditInvoiceIds;
    }
    if (invoicekind === SettlementReadInvoiceEnum.DriverShippingCostReduced) {
      ReadInvoiceModel.InvoiceIds = this.model.DriverShippingCostReducedIds;
    }
    if (invoicekind === SettlementReadInvoiceEnum.PaymentLink) {
      ReadInvoiceModel.InvoiceIds = this.model.PaymentLinkIds;
    }
    if (invoicekind === SettlementReadInvoiceEnum.OnlinePayment) {
      ReadInvoiceModel.InvoiceIds = this.model.OnlinePaymentIds;
    }
    if (!ReadInvoiceModel.InvoiceIds || ReadInvoiceModel.InvoiceIds.length === 0) return;
    this.dialogService
      .open(
        InvoicesModalComponent,
        {
          ReadInvoiceModel: ReadInvoiceModel,
          defaultFilters: [],
        },
        {
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {}),
      500;
  }
  removePayment(index: number) {
    const findIndex = this.model.ReceiptPayments.findIndex((f) => f.Index === index);
    this.model.ReceiptPayments.splice(findIndex, 1);
    this.formGroup.removeControl(`PaymentMethodId${index}`);
    this.formGroup.removeControl(`receivedmoney${index}`);
    this.calculate();
  }

  calculate() {
    this.model.TotalReciptPayment = 0;
    this.model.AllowedDeficit = 0;
    let isPosPaymentMethod = null;
    const selectedPersonnelId = this.formGroup.controls["SettledPersonnelId"].value;
    const selectedPersonnel = this.userLookup.find((user) => (user as DriverLookup).PersonnelId === selectedPersonnelId) as DriverLookup;

    const hasTerminalNumber = !!selectedPersonnel?.TerminalNumber;
    if (hasTerminalNumber) {
      this.model.TerminalNumber = selectedPersonnel?.TerminalNumber;
      this.setValue("TerminalNumber", selectedPersonnel?.TerminalNumber || "");
    }

    for (let index = 0; index < this.model.ReceiptPayments?.length; index++) {
      const i = this.model.ReceiptPayments[index].Index;
      const money = this.formGroup.controls[`receivedmoney${i}`];
      const paymentMethodId = this.formGroup.controls[`PaymentMethodId${i}`]?.value;
      if (money?.value) {
        const receiptPaymentId = this.formGroup.controls[`ReceiptPaymentTypeId${i}`].value;
        const isPayment = this.receiptPaymentType.find((x) => x.Id === receiptPaymentId)?.Code === ReceiptPaymentTypeEnum.Payment;

        if (isPayment) {
          this.model.TotalReciptPayment -= Number(money.value);
        } else {
          this.model.TotalReciptPayment += Number(money.value);
        }
      }
      const selectedPaymentMethod = this.model.ReceiptPayments[index].PaymentMethod.find((pm) => pm.Id === paymentMethodId);
      isPosPaymentMethod = selectedPaymentMethod?.PaymentMethodCode === PaymentMethodType.Pos;
      this.model.ReceiptPayments[index].PaymentMethodCode = selectedPaymentMethod.PaymentMethodCode;
      this.model.ReceiptPayments[index].hasTerminal = hasTerminalNumber && isPosPaymentMethod;
    }
    this.model.AllowedDeficit = Number(this.formGroup.controls[`AllowedDeficit`].value);
    this.model.Remain = this.model.TotalPayment - (this.model.TotalReciptPayment ? this.model.TotalReciptPayment : 0) - this.model.AllowedDeficit;
    this.setValue("Remain", this.model.Remain);
    this.checkValidation();
  }

  //اضافه کردن به فرم گروپ
  addGroup() {
    if (!this.model.ReceiptPayments || this.model.ReceiptPayments.length <= 0) {
      const ReceiptModel = new ReceiptPaymentModel();
      const index = Math.floor(Math.random() * 10000000);
      ReceiptModel.ReceiptPaymentType = JSON.parse(JSON.stringify(this.receiptPaymentType));
      ReceiptModel.PaymentMethod = JSON.parse(JSON.stringify(this.PaymentMethod));
      ReceiptModel.Index = index;
      if (!this.model.ReceiptPayments) this.model.ReceiptPayments = [];
      this.model.ReceiptPayments.push(ReceiptModel);
      this.setValue(`PaymentMethodId${index}`, this.PaymentMethod[0].Id, true);
      this.setValue(`ReceiptPaymentTypeId${index}`, this.receiptPaymentType[1].Id, true);
      this.setValue(`receivedmoney${index}`, this.model.TotalPayment, true);
    } else {
      if (this.model.ReceiptPayments && this.model.ReceiptPayments.length > 0 && !this.formGroup) {
        for (let i = 0; i < this.model.ReceiptPayments.length; i++) {
          const index = Math.floor(Math.random() * 10000000);
          this.model.ReceiptPayments[i].Index = index;
          this.setValue(`PaymentMethodId${index}`, this.model.ReceiptPayments[i].PaymentMethodId, true);
          this.setValue(`ReceiptPaymentTypeId${index}`, this.model.ReceiptPayments[i].ReceiptPaymentTypeId, true);
          this.setValue(`receivedmoney${index}`, this.model.ReceiptPayments[i].Amount, true);
          if (this.model.ReceiptPayments[i].PaymentMethod.length === 1) this.setValue(`PaymentMethodId${index}`, this.PaymentMethod[0].Id, true);
        }
      } else {
        if (this.model.ReceiptPayments && this.model.ReceiptPayments.length > 0) {
          const index = this.model.ReceiptPayments.length - 1;
          const i = Math.floor(Math.random() * 10000000);
          this.setValue(`PaymentMethodId${i}`, this.PaymentMethod[0].Id, true);
          this.setValue(`ReceiptPaymentTypeId${i}`, this.receiptPaymentType[1].Id, true);
          this.setValue(`receivedmoney${i}`, this.model.ReceiptPayments[index].Amount, true);
          this.model.ReceiptPayments[index].State = RowState.New;
          this.model.ReceiptPayments[index].Index = i;
          if (this.model.ReceiptPayments[index].PaymentMethod.length === 1) this.setValue(`PaymentMethodId${i}`, this.PaymentMethod[0].Id, true);
          else {
            if (this.model.ReceiptPayments[index].PaymentMethodId) {
              this.setValue(`PaymentMethodId${i}`, this.model.ReceiptPayments[index].PaymentMethodId, true);
              this.setValue(`ReceiptPaymentTypeId${i}`, this.model.ReceiptPayments[index].ReceiptPaymentTypeId, true);
              this.setValue(`receivedmoney${i}`, this.model.ReceiptPayments[index].Amount, true);
            }
          }
        }
      }
    }
    this.checkValidation();
    this.calculate();
  }
  // فعال کردن دکمه تسویه
  checkValidation() {
    const controls = this.formGroup.controls;
    const debit = controls["Debit"].value || 0;
    const credit = controls["Credit"].value || 0;
    const paymentLink = controls["PaymentLink"].value || 0;
    const totalDeposit = controls["TotalDeposit"].value || 0;
    const onlinePayment = controls["OnlinePayment"].value || 0;
    const totalPayment = controls["TotalPayment"].value || 0;
    const payableTotal = controls["PayableTotal"].value || 0;
    const allowedDeficit = controls["AllowedDeficit"].value || 0;
    const combinedPayment = debit + credit + paymentLink + totalDeposit + onlinePayment;
    if (
      (this.formGroup?.valid && totalPayment > 0 && (this.model.ReceiptPayments.length > 0 || allowedDeficit > 0)) ||
      (this.formGroup?.valid && totalPayment > 0 && payableTotal === totalPayment) ||
      (this.formGroup?.valid && debit > 0 && payableTotal === debit) ||
      (this.formGroup?.valid && combinedPayment > 0 && payableTotal === combinedPayment)
    ) {
      this.deactivateSave = false;
    } else {
      this.deactivateSave = true;
      // this.isSaved = false;
    }
  }
  clear(value: any) {
    if (value === 0) {
      this.formGroup.controls[`receivedmoney`].setValue(0);
      this.calculate();
    }
    if (value === 1) {
      this.formGroup.controls[`AllowedDeficit`].setValue(0);
      this.calculate();
    }
  }
  addPayment() {
    const SettlementDetail = new ReceiptPaymentModel();
    const index = Math.floor(Math.random() * 10000000);
    SettlementDetail.ReceiptPaymentType = JSON.parse(JSON.stringify(this.receiptPaymentType));
    SettlementDetail.PaymentMethod = JSON.parse(JSON.stringify(this.PaymentMethod));
    SettlementDetail.Index = index;
    this.model.ReceiptPayments.push(SettlementDetail);
    this.addGroup();
  }
  async saveSettlement(model: DriverSettlementModel) {
    this.splashFormService.openDialog();
    if (!this.model.FiscalYearId && this.accountService.authService.currentFiscalYear)
      this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    this.model.Invoices = [];
    //this.model.ReceiptPayments = [];
    this.model.Invoice.forEach((element) => {
      const set = new SettlementInvoiceModel();
      set.InvoiceId = element.Id;
      this.model.Invoices.push(set);
    });
    for (let index = 0; index < this.model.ReceiptPayments.length; index++) {
      const i = this.model.ReceiptPayments[index].Index;
      this.model.ReceiptPayments[index].PaymentMethodId = this.formGroup.controls[`PaymentMethodId${i}`].value;
      this.model.ReceiptPayments[index].Amount = this.formGroup.controls[`receivedmoney${i}`].value;
      this.model.ReceiptPayments[index].ReceiptPaymentTypeId = this.formGroup.controls[`ReceiptPaymentTypeId${i}`].value;
      this.model.ReceiptPayments[index].BranchId = this.accountService.authService.currentBranchId;
    }
    /// <summery>
    /// برای معماری قبلی بود که الان احتیاجی بهش نداریم
    //if (this.formGroup.controls[`Remain`].value > 0) {
    //  const SettlementDetail = new ReceiptPaymentModel();
    //  SettlementDetail.IsRemain = true;
    //  SettlementDetail.Amount = - Number(this.formGroup.controls[`Remain`].value);
    //  this.model.ReceiptPayments.push(SettlementDetail);
    //}
    this.model.ReceiptPayments = JSON.parse(JSON.stringify(this.model.ReceiptPayments));
    this.sts.showToast("info", "", this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.SavingChanges"));
    this.isSaving = true;
    this.isSaved = false;
    this.model.TotalPayment = this.formGroup.controls["TotalPayment"].value;
    this.model.PayableTotalPrice = this.model.PayableTotal;
    this.model.Description = this.formGroup.controls["Description"].value;
    this.model.DriverFirstNameTitle = this.userLookup?.find((f) => f.Id === this.formGroup.controls["SettledPersonnelId"].value)?.Title;
    this.model.DriverLastNameTitle = this.userLookup?.find((f) => f.Id === this.formGroup.controls["SettledPersonnelId"].value)?.Title;
    this.httpCommonService
      .create("DriverSettlement", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          data;
          this.splashFormService.closeLoading();
          this.close();
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showToast("danger", "", `${Utilities.getHttpResponseMessage(error)}`);
        }
      );
    this.isClosing = false;
    this.submitted = true;
    // this._tabsservice.tabItemonRefreshData.next('DriverSettlement');
    // this.model.Invoice = JSON.parse(JSON.stringify(this.invoice));
    this.sts.showToast(
      "success",
      this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.successful"),
      `${this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.InformationChanges")}  ${this.label}  ${this.translate(
        "ClientApp.FrontOffice.Financial.DriverSettlement.SavedSuccessfully"
      )} `
    );
    this.result = true;
  }
  async save() {
    const ShippingCostReducedKindId = this.accountService.authService.currentBranch.ShippingCostReducedKindId;
    if (ShippingCostReducedKindId) this.ShippingCostReducedKindCode = this.lookupservice.getLookupbyId(ShippingCostReducedKindId).Code;
    if (this.model.TerminalNumber) {
      this.model.TerminalNumber = this.formGroup.controls["TerminalNumber"].value;
    }
    if (
      this.ShippingCostReducedKindCode != ShippingCostReducedKind.NoReduced &&
      this.model.CostSpentFormSettingViewModel &&
      this.hasAccountingModule &&
      !this.model.CostSpentFormSettingViewModel.Subledger &&
      !this.model.CostSpentFormSettingViewModel.DetailLedger
    ) {
      this.sts.showDialog(this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.SelectPreferenceInSpendingCost"), "");
      this.close();
      return;
    }
    if (
      this.model.CostSpentFormSettingViewModel &&
      this.hasAccountingModule &&
      this.model.CostSpentFormSettingViewModel.Subledger &&
      !this.model.CostSpentFormSettingViewModel.DetailLedger &&
      this.hasDetailLedger
    ) {
      this.sts.showDialog(this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.SelectPaymentPreference"), "");
      this.close();
      return;
    }
    if (this.model.DriverSettlementFormSettingModel?.CostGroupId && !this.model.DriverSettlementFormSettingModel?.CostId) {
      this.dialogService
        .open(
          DriversettlementsettingFormComponent,
          { currentrow: this.model.DriverSettlementFormSettingModel, hasDefaultCostId: false },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .subscribe((model: any) => {
          if (model?.CostId) {
            this.model.DriverSettlementFormSettingModel.CostId = model.CostId;
            this.model.DriverSettlementFormSettingModel.CostGroupId = model.CostGroupId;
            this.model.DriverSettlementFormSettingModel.DeductionForSettlement = model.DeductionForSettlement;
            this.saveSettlement(this.model);
          } else this.sts.showToast("danger", this.translate("ClientApp.FrontOffice.Financial.DriverSettlement.SelectFeeFirst"));
          return;
        });
    } else {
      this.saveSettlement(this.model);
    }
  }
}
